import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

import type { LinkedInGroup } from "../types";

async function getUserGroupsRequest(
  workspaceId: string,
  accountId: string,
): Promise<LinkedInGroup[]> {
  return (await get(`workspaces/${workspaceId}/accounts/${accountId}/groups`))
    .groups;
}

export default function useLinkedInGroups(accountId: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { leadListSourcesKeys } = getQueryKeys(workspaceId);

  const { data: linkedInGroups, isLoading: isLoadingLinkedInGroups } = useQuery(
    {
      queryKey: leadListSourcesKeys.linkedInGroups(accountId),
      queryFn: () => getUserGroupsRequest(workspaceId, accountId),
      enabled: !!accountId,
    },
  );

  return {
    linkedInGroups,
    isLoadingLinkedInGroups,
  };
}
